import { Button } from "@mui/material";
import { FC } from "react";
interface ICustomButtonProps {
  text: string;
  variant?: any;
  onClick: any;
  underLine?: any;
  icon?: JSX.Element;
  iconPlacement?: string;
  externalClass?: string;
  disabled?: boolean;
}
const CustomButtonComponent: FC<ICustomButtonProps> = ({
  variant,
  onClick,
  underLine,
  icon,
  text,
  iconPlacement,
  externalClass,
  disabled
}) => {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      className={externalClass}
      sx={{
        textDecoration: underLine && "underline",
        textTransform: "none",
        backgroundColor: variant === "contained" ? "var(--primary-color)" : "",
        color:
          variant === "contained"
            ? "var(--contained-button-text)"
            : "var(--button-text)",
        borderColor: variant === "outlined" ? "var(--button-text)" : "",
        "&:hover": {
          backgroundColor: variant === "contained" ? "var(--primary-color)" : ""
        },
        fontWeight: variant === "contained" ? 800 : 700
      }}
      disabled={disabled}
    >
      {iconPlacement === "right" ? (
        <>
          <>{text}</> <>{icon}</>
        </>
      ) : iconPlacement === "left" ? (
        <>
          <>{icon}</> <>{text}</>
        </>
      ) : (
        text
      )}
    </Button>
  );
};

export default CustomButtonComponent;
